import { ASSET_DIR, STRINGS } from '@/constants/farmerSolutions'
import styles from '@/styles/PremiumMembership.module.css'

import Picture from '../picture'

const PremiumMembership = () => (
  <section className={styles.premium}>
    <section className="px-6 mt-4 max-w-7xl m-auto pt-14 pb-6 md:pt-[100px] md:pb-[135px] text-[#f4ebd0]">
      <h3 className="font-medium font-natosans-medium text-[28px] leading-[1.1875] md:hidden mb-9">
        {STRINGS.PREMIUM_MEMBERSHIP}
      </h3>
      <section className="flex items-center md:flex-row flex-col">
        <Picture
          image={`${ASSET_DIR}/sampoorna`}
          imageAlt={STRINGS.PREMIUM_MEMBERSHIP}
          pictureStyle="md:w-1/2 flex items-center justify-center"
          imageStyle="md:max-w-[476px] w-full"
        />
        <article className="md:w-1/2 md:pl-[30px]">
          <h3 className="font-semibold font-natosans-semibold text-4xl leading-[1.1875] hidden md:block">
            {STRINGS.PREMIUM_MEMBERSHIP}
          </h3>
          <p className="mt-10 md:mt-4 whitespace-pre-wrap leading-[1.6] text-lg">
            {STRINGS.PREMIUM_MEMBERSHIP_DESC}
          </p>
        </article>
      </section>
    </section>
  </section>
)

export default PremiumMembership
